<div class="wrapper">
  <div class="button-wrapper" tabindex="0" (click)="photoUploader.click()">
    <orbit-button
      [styleClass]="'addon-button'"
      rounded
      [icon]="imageIcon"
      [testId]="'btn-browse-file'" />
    <p>{{ 'SHARED.FOOTER_ADDON_USER.ALBUM' | translate }}</p>
    <input
      hidden
      data-testid="input-browse-file"
      #photoUploader
      id="photoUploader"
      type="file"
      name="photoUploader"
      accept="image/*,video/*"
      (change)="onFileSelected($event, footerButtonTypeEnum.Album)" />
  </div>
  @if (senderType() === messageSenderTypeEnum.Client) {
    @if (supportsCaptureAttribute()) {
      <div class="button-wrapper" tabindex="1" (click)="cameraUploader.click()">
        <orbit-button
          [styleClass]="'addon-button'"
          rounded
          [icon]="cameraIcon"
          [testId]="'btn-camera'" />
        <p>{{ 'SHARED.FOOTER_ADDON_USER.CAMERA' | translate }}</p>
        <input
          hidden
          data-testid="input-camera"
          #cameraUploader
          id="cameraUploader"
          name="cameraUploader"
          type="file"
          accept="image/*"
          capture="camera"
          (change)="onFileSelected($event, footerButtonTypeEnum.Camera)" />
      </div>
    } @else {
      <div
        class="button-wrapper"
        tabindex="1"
        (click)="buttonClick.emit(footerButtonTypeEnum.WebCamera)">
        <orbit-button
          [styleClass]="'addon-button'"
          rounded
          [icon]="cameraIcon"
          [testId]="'btn-user-camera'" />
        <p>{{ 'SHARED.FOOTER_ADDON_USER.CAMERA' | translate }}</p>
        <input
          hidden
          data-testid="input-user-camera"
          #cameraUploader
          id="cameraUploader"
          name="cameraUploader"
          type="file"
          accept="image/*"
          capture="camera"
          (change)="onFileSelected($event, footerButtonTypeEnum.Camera)" />
      </div>
    }
    <div class="button-wrapper" tabindex="1" (click)="videoUploader.click()">
      <orbit-button
        [styleClass]="'addon-button'"
        rounded
        [icon]="videoIcon"
        [testId]="'btn-video'" />
      <p>{{ 'SHARED.FOOTER_ADDON_USER.VIDEO' | translate }}</p>
      <input
        hidden
        data-testid="input-video"
        #videoUploader
        id="videoUploader"
        name="videoUploader"
        type="file"
        accept="video/*"
        capture="camcorder"
        (change)="onFileSelected($event, footerButtonTypeEnum.Video)" />
    </div>
    @if (!isSafari()) {
      <div class="button-wrapper" tabindex="2" (click)="audioUploader.click()">
        <orbit-button
          [styleClass]="'addon-button'"
          rounded
          [icon]="microphoneIcon"
          [testId]="'btn-audio'" />
        <p>{{ 'SHARED.FOOTER_ADDON_USER.AUDIO' | translate }}</p>
        <input
          hidden
          data-testid="input-audio"
          #audioUploader
          id="audioUploader"
          name="audioUploader"
          type="file"
          accept="audio/*"
          capture="microphone"
          (change)="onFileSelected($event, footerButtonTypeEnum.Audio)" />
      </div>
    }
    <div
      class="button-wrapper"
      tabindex="3"
      (click)="buttonClick.emit(footerButtonTypeEnum.Location)">
      <orbit-button
        [styleClass]="'addon-button'"
        rounded
        [icon]="locationDotIcon"
        [testId]="'btn-location'" />
      <p>{{ 'SHARED.FOOTER_ADDON_USER.LOCATION' | translate }}</p>
    </div>
  }
  @if (senderType() === messageSenderTypeEnum.TenantUser) {
    <div
      class="button-wrapper"
      tabindex="1"
      (click)="buttonClick.emit(footerButtonTypeEnum.WebCamera)">
      <orbit-button
        [styleClass]="'addon-button'"
        rounded
        [icon]="cameraIcon"
        [testId]="'btn-user-camera'" />
      <p>{{ 'SHARED.FOOTER_ADDON_USER.CAMERA' | translate }}</p>
      <input
        hidden
        data-testid="input-user-camera"
        #cameraUploader
        id="cameraUploader"
        name="cameraUploader"
        type="file"
        accept="image/*"
        capture="camera"
        (change)="onFileSelected($event, footerButtonTypeEnum.Camera)" />
    </div>
    <div
      class="button-wrapper"
      tabindex="2"
      (click)="buttonClick.emit(footerButtonTypeEnum.Location)">
      <orbit-button
        [styleClass]="'addon-button'"
        rounded
        [icon]="locationDotIcon"
        [testId]="'btn-user-location'" />
      <p>{{ 'SHARED.FOOTER_ADDON_USER.LOCATION' | translate }}</p>
    </div>
    @if (showRequestLocationButton()) {
      <div
        class="button-wrapper"
        tabindex="3"
        (click)="buttonClick.emit(footerButtonTypeEnum.MsgLocation)">
        <orbit-button
          [styleClass]="'addon-button'"
          rounded
          [icon]="locationRequestIcon"
          [testId]="'btn-user-location-request'" />
        <p>{{ 'SHARED.FOOTER_ADDON_USER.INQUIRY' | translate }}</p>
      </div>
    }
  }
</div>
